const SearchDataParser = function(searchDataRaw, searchDataExpandedRaw) {
  const searchData = [];
  const searchDataExpanded = [];

  for(var i = 0; i < searchDataRaw.length; i++) {
    var item = {name: searchDataRaw[i].name, type: false, tagId: searchDataRaw[i].tags[0].id, placeId: searchDataRaw[i].id, lat: searchDataRaw[i].geo[0].coords.lat, lng: searchDataRaw[i].geo[0].coords.lng};
    for(var t in searchDataRaw[i].tags) {
      if(searchDataRaw[i].tags[t].primary) {
        item.tagId = searchDataRaw[i].tags[t].id;
        break;
      }
    }

    searchData.push(item);
    searchDataExpanded.push(item);
  }

  for(var i = 0; i < searchDataExpandedRaw.length; i++) {
    if(searchDataExpandedRaw[i].tags.length != 0 && searchDataExpandedRaw[i].geo.length != 0) {
      var item = {name: searchDataExpandedRaw[i].name, type: searchDataExpandedRaw[i].tags[0].name, tagId: searchDataExpandedRaw[i].tags[0].id, placeId: searchDataExpandedRaw[i].id, lat: searchDataExpandedRaw[i].geo[0].coords.lat, lng: searchDataExpandedRaw[i].geo[0].coords.lng};
      searchDataExpanded.push(item);
    }
  }

  return {searchData, searchDataExpanded};
};

export default SearchDataParser;
